import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu']

  connect() {
    this.close = this.close.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden')
    // Add click listener to close when clicking outside
    document.addEventListener('click', this.close)
  }

  close() {
    this.menuTarget.classList.add('hidden')
    // Remove click listener
    document.removeEventListener('click', this.close)
  }

  hide(event) {
    // Close dropdown when clicking outside
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}